import { useState, useEffect, useRef, SetStateAction } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { useAuth } from '../providers/auth';
import api from "../services/api";
import { useToast } from '../context/ToastContext';
import { ALERTAS, TIPO_CURSO, TURNOS } from '../utilities/constantes';
import util from '../utilities/util';
import { Divider } from 'primereact/divider';
import { useForm } from 'react-hook-form';
import { SCButton, SCCheckbox, SCDialog, SCInputText } from '../components';
import { SlideMenu } from 'primereact/slidemenu';
import AjudaFormTela from './AjudaFormTela';
import TurmasForm from './TurmasForm';
import ITurmas from '../interfaces/ITurmas';
import Loading from '../components/Loading';
import { Parser } from 'expr-eval';
import { PickList } from 'primereact/picklist';
import { ItemInterface, ReactSortable, Store } from "react-sortablejs";


const Teste = () => {
    const toast = useToast();
    const { periodoSelecionado } = useAuth();
    const tarefa = 'Teste';


    const dt = useRef<any>(null);
    const menu = useRef<any>(null);

    const [result, setResult] = useState<any>();
    const [selecionadas, setSelecionadas] = useState<string[]>([]);

    const methods = useForm({});
    const { handleSubmit, control, formState: { errors }, getValues, setValue } = methods;

    const load = async () => {
        const aluno = await api.get('/boletim/aluno', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                Matricula: 2404339,
            }
        })
        setResult(aluno.data)

        console.log(aluno.data)
    }

    useEffect(() => {
        load()
    }, []);

    const onSubmit = async (data: any) => {
        await load();
    }

    const opcoes = [
        {
            label: 'Imprimir',
            icon: 'pi pi-print',
            command: () => {
                dt.current.exportCSV();
            }
        },
        {
            label: 'Exp. para Excel',
            icon: 'pi pi-file-excel',
            command: () => {
                dt.current.exportCSV();
            }
        },
        {
            label: 'Ajuda',
            icon: 'pi pi-question-circle',
            command: () => {
                dt.current.exportCSV();
            }
        },
    ];

    const simu = (num: number) => {
        setValue('texto', 'Boletim.Nota' + num)
    }

    const teste2 = () => {
        if (getValues('texto').includes('1')) {
            setValue('Resultado', result[0].NotaB1)
        } else {
            setValue('Resultado', result[0].NotaB2)
        }
    }

    const check = (nota: string, checked: boolean) => {
        let atualizadas = [...selecionadas];

        if (checked) {
            atualizadas.push(nota);
        } else {
            atualizadas = atualizadas.filter(n => n !== nota);
        }

        setSelecionadas(atualizadas);

        const textoFinal = atualizadas.map(n => `Boletim.${n}`).join(' + ');
        setValue('texto', textoFinal);
    };

    // const calcularResultado = () => {
    //     // const texto = getValues('texto');
    //     // if (!result?.[0]) return;

    //     // const soma = selecionadas.reduce((acc, nota) => {
    //     //     const valor = parseFloat(result[0][nota]) || 0;
    //     //     return acc + valor;
    //     // }, 0);

    //     // setValue('Resultado', soma.toFixed(2));

    //     // const valores = selecionadas.map(nota => result[0][nota] ?? '-');
    //     // const resultadoTexto = valores.join(', ');

    //     // setValue('Resultado', resultadoTexto);
    // };

    const calcularResultado = () => {
        const parser = new Parser();
        const formula = getValues('texto');

        const expr = parser.parse(formula);
        const resultado = expr.evaluate();
        setValue('Resultado', resultado.toFixed(2));

    };

    const handleFormulaInput = (e: any) => {
        const entrada = e.target.value;
        setValue('formulaBruta', entrada);

        if (!result?.[0]) return;

        let formulaComValores = entrada.replace(/notab(\d)/gi, (_: any, numero: any) => {
            const chave = `NotaB${numero}`;
            const valor = parseFloat(result[0][chave]) || 0;
            return valor.toString();
        });

        setValue('texto', formulaComValores);
    };

    const listaNotas = ['NotaB1', 'NotaB2', 'NotaB3', 'NotaB4', 'NotaB5', 'NotaB6'];

    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    // useEffect(() => {
    //     ProductService.getProductsSmall().then((data: SetStateAction<never[]>) => setSource(data));
    // }, []);

    const onChange = (event: any) => {
        setSource(event.source);
        setTarget(event.target);
    };

    const itemTemplate = (item: any) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                <img className="w-4rem shadow-2 flex-shrink-0 border-round" src={`https://primefaces.org/cdn/primereact/images/product/${item.image}`} alt={item.name} />
                <div className="flex-1 flex flex-column gap-2">
                    <span className="font-bold">{item.name}</span>
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-tag text-sm"></i>
                        <span>{item.category}</span>
                    </div>
                </div>
                <span className="font-bold text-900">${item.price}</span>
            </div>
        );
    };

    const nomesFixos = [
        "Coluna 1", "Coluna 2", "Coluna 3", "Coluna 4", "Coluna 5",
        "Coluna 6", "Coluna 7", "Coluna 8", "Coluna 9", "Coluna 10",
        "Coluna 11", "Coluna 12", "Coluna 13", "Coluna 14", "Coluna 15",
        "Coluna 16", "Coluna 17", "Coluna 18", "Coluna 19", "Coluna 20"
    ];

    const [state, setState] = useState(
        Array.from({ length: 20 }, (_, i) => ({
            id: `${i + 1}`,
            value: ""
        }))
    );

    const handleInputChange = (id: number | string, newValue: any) => {
        setState(prev =>
            prev.map(item => (item.id === id ? { ...item, value: newValue } : item))
        );
    };

    return (
        <div className="grid">
            <div className="col-12">
                {listaNotas.map(nota => (
                    <div className='grid flex'>
                        <div className="mr-4 col-2">
                            <SCCheckbox
                                inputId={nota}
                                label={nota}
                                name={nota}
                                checked={selecionadas.includes(nota)}
                                onChange={(e) => check(nota, e.checked)}
                            />
                        </div>
                    </div>
                ))}
            </div>
            <div className='pt-4 col-6'>
                <SCInputText control={control} name='formulaBruta' label='Fórmula' onInput={handleFormulaInput} />
                <SCInputText control={control} name='texto' label='Fórmula Valor' disabled />
            </div>
            <div className='col-12'>
                <SCButton label='Resultado' onClick={calcularResultado} />
            </div>
            <div className='pt-4 col-6'>
                <SCInputText control={control} name='Resultado' label='Resultado' />
            </div>
            {/* <div className="card">
                <PickList
                    dataKey="id"
                    source={source}
                    target={target}
                    onChange={onChange}
                    itemTemplate={itemTemplate}
                    filter
                    filterBy="name"
                    breakpoint="1280px"
                    sourceHeader="Available"
                    targetHeader="Selected"
                    sourceStyle={{ height: '24rem' }}
                    targetStyle={{ height: '24rem' }}
                    sourceFilterPlaceholder="Search by name"
                    targetFilterPlaceholder="Search by name"
                />
            </div> */}

            {/* <ReactSortable list={state} setList={setState} className="grid">
                {state.map((item, index) => (
                    <div
                        key={item.id}
                        className="card"
                        style={{
                            width: "100px",
                            height: "100px",
                            border: "1px solid #ccc",
                            margin: "10px",
                            padding: "10px",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                        }}
                    >
                        <div>{nomesFixos[index]}</div>
                        <label style={{ fontWeight: "bold" }}>Nota {item.id}</label>
                        <SCInputText
                            value={item.value}
                            onChange={e => handleInputChange(item.id, e.target.value)}
                        />
                    </div>
                ))}
            </ReactSortable> */}
        </div>
    );
};

export default Teste;
